module.exports = __webpack_public_path__ + "img/waves.bfeb0b98.jpg";